import React from 'react'

import { SectionContainerStyled } from 'components/atoms/container/index.styled'
import { IResumeGroup } from 'interfaces/categories.interface'
import styled from 'styled-components'

const GroupResumeStyled = styled(SectionContainerStyled)`
  .divider {
    border-bottom: 1px solid ${(props) => props.theme.mbColors.lightGray};
  }
  .group {
    display: flex;
    align-items: center;
    svg {
      max-width: 100%;
    }
    .period {
      font-size: 12px;
    }
    .icon {
      width: 24px;
      height: 24px;
      text-align: center;
    }
    .content {
      flex-grow: 1;
      padding: 16px 0;
      margin-left: 16px;
      font-weight: 600;
    }
    .content.detail {
      font-weight: normal;
    }
  }
`

const ResumeGroup = ({
  icon,
  label,
  details,
  isDetail,
  hasDivider = true,
}: IResumeGroup) => {
  const dividerClassName = details || hasDivider ? 'divider' : ''
  const detailClassName = isDetail ? 'detail' : ''
  return (
    <GroupResumeStyled>
      <section className="group">
        <div className="icon">{icon}</div>
        <div className={`content ${dividerClassName} ${detailClassName}`}>
          {label}
        </div>
      </section>
      {details?.map((detail, index) => (
        <ResumeGroup
          isDetail
          key={`${index}`}
          hasDivider={details.length === index + 1}
          {...detail}
        />
      ))}
    </GroupResumeStyled>
  )
}

export default ResumeGroup
